export default {
  apiKey: "AIzaSyAywty4JSKhupzfy00LOfxswNGsLiZlf_k",
    authDomain: "indetail-affairs.firebaseapp.com",
    databaseURL: "https://indetail-affairs.firebaseio.com",
    projectId: "indetail-affairs",
    storageBucket: "indetail-affairs.appspot.com",
    messagingSenderId: "1073913642220",
    appId: "1:1073913642220:web:13ff59cfeafc86493439c9",
    measurementId: "G-8F8MSSZQSK"
};
  